import Skeleton from "./Skeleton";

export default function CalendarMainSkeleton() {
  return (
    <div className="flex gap-4 w-full p-2">
      <div className="w-full space-y-4">
        {/* Calendar Grid 7 × 6 */}
        <div className="grid grid-cols-7 grid-rows-6 gap-1 h-[600px]">
          {Array.from({ length: 42 }).map((_, i) => (
            <div
              key={i}
              className="border rounded p-2 flex flex-col gap-2 overflow-hidden"
            >
              <Skeleton className="h-4 w-8" />

              <div className="flex flex-wrap gap-1 mt-1">
                <Skeleton className="h-3 w-6" />
                <Skeleton className="h-3 w-6" />
                <Skeleton className="h-3 w-6" />
              </div>

              <div className="flex flex-col gap-1 mt-auto">
                <Skeleton className="h-2 w-full" />
                <Skeleton className="h-2 w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
